import {
  CircularProgress,
  DialogContent,
  Divider,
  Stack,
  styled,
  Typography,
} from '@mui/material';

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  gap: theme.spacing(2),
}));

export const StyledHeader = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'baseline',
  justifyContent: 'space-between',
});

export const StyledTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: 32,
  lineHeight: '45px',
  color: theme.palette.grey[900],
  margin: 0,
  maxWidth: theme.spacing(32),
}));
StyledTitle.defaultProps = {
  variant: 'h2',
};

export const StyledSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[900],
}));
StyledSubtitle.defaultProps = {
  variant: 'body1',
};

export const StyledCicularProgress = styled(CircularProgress)(({ theme }) => ({
  display: 'flex',
  alignSelf: 'center',
  margin: theme.spacing(10),
}));
StyledCicularProgress.defaultProps = {
  color: 'primary',
};

export const StyledStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'baseline',
  gap: theme.spacing(0.5),
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
}));
